import { Component, OnInit, OnChanges, SimpleChanges, Input } from '@angular/core';
import { ApiservicesService } from '../../apiservices.service';
import { EncryptdecryptService } from '../../services/encryptdecrypt.service';
import { SidebarProfileComponent } from '../sidebar-profile/sidebar-profile.component';

@Component({
  selector: 'app-user-top',
  templateUrl: './user-top.component.html',
  styleUrls: ['./user-top.component.css']
})
export class UserTopComponent implements OnInit, OnChanges {

  //UI View Variables
  NameView: any = "";
  RoleView: any = "";
  FirmNameView: any = "";
  TotalAppointted: Number = 0;

  //Token Variables
  RequestTokenResult: any;

  //Parents Variables
  CurrentRoles: any[] = [];

  //Session
  StaffRolesUpdated: any[] = [];

  @Input() Roles:any[] = [];
  @Input() FirmID: any = "";

  constructor(private apiServices: ApiservicesService, private encryptDecryptService: EncryptdecryptService) { }
  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    this.RoleView = "";
    this.CurrentRoles = [];
    if (changes['FirmID'] !== undefined) {
      let Firm = changes['FirmID'];
      if (Firm.firstChange === false) {
        await this.GetStaffRole(this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffIDNo') || ''), Firm.currentValue, true);
        await this.GetFirmDetail(Firm.currentValue);
        await this.GetAgentDetails(this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffIDNo') || ''), Firm.currentValue);
      }
    }
  }

  ngOnInit(): void {
    this.getName();
    this.GetStaffRole(this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffIDNo') || ''), this.encryptDecryptService.decrypt(sessionStorage.getItem('FirmID') || ''), false);
    this.GetFirmDetail(this.encryptDecryptService.decrypt(sessionStorage.getItem('FirmID') || ''));
  }

  async getName() {
    const result = await this.apiServices.RequestToken();
    this.NameView = result.body.FullName;
  }

  async GetStaffRole(StaffIDNo: any, FirmID: any, Login: boolean) {
    sessionStorage.removeItem('StaffRoles');
    this.StaffRolesUpdated = [];
    const result = await this.apiServices.GetFirmUserByICNO(StaffIDNo, FirmID, Login);
    result.forEach((currentValue: any, index: any) => {
      this.StaffRolesUpdated.push(result[index].userGroup);
      if (result[index].userGroup === "0201") {
        this.RoleView = this.RoleView.length !== 0 ? this.RoleView + " | PENTADBIR" : "PENTADBIR";
      } else if (result[index].userGroup === "0202") {
        this.RoleView = this.RoleView.length !== 0 ? this.RoleView + " | PENYELIA" : "PENYELIA";
      } else if (result[index].userGroup === "0203") {
        this.RoleView = this.RoleView.length !== 0 ? this.RoleView + " | STAF" : "STAF";
      } else if (result[index].userGroup === "0204") {
        this.RoleView = this.RoleView.length !== 0 ? this.RoleView + " | EJEN CUKAI" : "EJEN CUKAI";
      }
    });
    sessionStorage.setItem('StaffRoles', this.encryptDecryptService.encrypt(JSON.stringify(this.StaffRolesUpdated)));
  }

  async GetFirmDetail(FirmID:any) {
    const result = await this.apiServices.GetFirmDetailByID(FirmID);
    this.FirmNameView = result.name;
  }

  async GetAgentDetails(IDNo: any, FirmID: any) {
    sessionStorage.removeItem('TaxAgentID');
    let Params = {
      "IDNo": IDNo,
      "FirmID": FirmID
    }
    const result = await this.apiServices.GetAgentDetailByIDNo(Params);
    if (result.hasError === true)
      sessionStorage.removeItem('TaxAgentID');
    else
      sessionStorage.setItem('TaxAgentID', this.encryptDecryptService.encrypt(result.taxAgentId));
  }

  public updateTotal() {
    this.GetTotal().then(() => {
      document.getElementById('totalNoti')!.innerHTML = this.TotalAppointted.toString();
      document.getElementById('totalNotiInner')!.innerHTML = this.TotalAppointted.toString();
    });
  }
  async GetTotal() {
    let Params = {
      "FirmID": Number(this.encryptDecryptService.decrypt(sessionStorage.getItem('FirmID') || '')),
      "TaxAgentID": Number(this.encryptDecryptService.decrypt(sessionStorage.getItem('TaxAgentID') || ''))
    };
    const result = await this.apiServices.GetTotalAppointed(Params);
    this.TotalAppointted = result;
  }
}
